import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import { dispatch } from 'store';

import { RootState } from 'types';
import { clearAuthError, forgotPassword } from 'modules/auth/actions';
import { setNotification } from 'modules/app/actions';

import { Input, Button } from 'views/components';
import { AuthLeftBlock } from '../components/AuthLeftBlock';

import { t } from 'utils';
import styles from './ForgotPassword.module.css';
import { routes } from 'routes';

import texts from './texts';

export const ForgotPassword: FC = () => {
  const { errors, loading } = useSelector((state: RootState) => state.auth);
  const { windowWidth, notification } = useSelector((state: RootState) => state.app);

  const [forgotEmail, setForgotEmail] = useState('');

  useEffect(() => {
    dispatch(clearAuthError());
  }, []);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  return (
    <div className={styles.wrap}>
      <AuthLeftBlock title={t(texts.title)} backTo={t(texts.backToLogin)} />
      <div className={styles.rightBlock}>
        <div className={styles.rightBlockWrap}>
          {windowWidth > 1140 && (
            <div className={styles.linkItem}>
              <Link className={styles.link} to={routes.signin}>
                {t(texts.backToLogin)}
              </Link>
            </div>
          )}

          <Input
            name="email"
            value={forgotEmail}
            onChange={(e: any) => setForgotEmail(e.target.value)}
            label={t(texts.inputLabel1)}
            error={errors.email}
            whiteLabel={windowWidth < 1140}
          />

          <div className={styles.buttonWrap}>
            <Button
              title={t(texts.resetPassword)}
              loading={loading}
              onClick={() => dispatch(forgotPassword.request(forgotEmail))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
